import { Injectable, signal, Signal } from "@angular/core";
import { UserResult } from "../models/login.model";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { formatDate } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class GlobalServiceService {
  userData = signal<UserResult | null>(null);
  // flyoutCloseSignal = signal<boolean>(false);
  // isResetFlyout = true;
  isLoggedInUserAdmin = this.userData()?.["isAdmin"] ?? false;
  isMobile = false;
  constructor(private breakpointObserver: BreakpointObserver) {
    this.checkDevice();
  }
  private checkDevice() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });
  }
  getCPToken(): string {
    return localStorage.getItem("CPToken") ?? "";
  }
  setCPToken(token: string): void {
    localStorage.setItem("CPToken", token);
  }
  setUserInfo(userInfo: UserResult): void {
    this.userData.set(userInfo);
    // localStorage.setItem("UserInfo", JSON.stringify(userInfo));
  }

  validateValueByRegex(
    input: string,
    pattern: RegExp | string,
    flags?: string
  ): boolean {
    const regex =
      pattern instanceof RegExp ? pattern : new RegExp(pattern, flags);
    return regex.test(input);
  }

  // closeFlyoutHandle(flag = true) {
  //   this.flyoutCloseSignal.set(flag);
  // }
  // getUserInfo(): UserResult | null {
  //   // return this.tempData;
  //   // const userInfo = localStorage.getItem("UserInfo");
  //   // return userInfo ? (JSON.parse(userInfo) as UserResult) : null;
  // }

  convertUtcToLocalString(utcString: string): string {
    const [month, day, yearAndTime] = utcString.split("/");
    const [year, time] = yearAndTime.split(" ");
    const localDate = new Date(`${year}-${month}-${day}T${time}Z`);

    return formatDate(localDate, "yyyy-MM-dd HH:mm:ss", "en-US");
  }

  combineDateAndTimeToString(datePart: Date, timePart: Date): string {
    const combined = new Date(
      datePart.getFullYear(),
      datePart.getMonth(),
      datePart.getDate(),
      timePart.getHours(),
      timePart.getMinutes(),
      timePart.getSeconds(),
      timePart.getMilliseconds()
    );
    // const format = formatDate(combined, "yyyy-MM-dd'T'HH:mm:ss.SSS", "en-us");

    // Format as UTC with 'Z' suffix
    return formatDate(
      combined,
      "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      "en-US",
      "UTC" // <-- key: format as UTC
    );
    // return combined.toISOString();
  }
  transform(value: string, limit: number = 30, trail: string = "..."): string {
    if (!value) {
      return "";
    }
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
